import { IOrderByTable } from '@/modules/AutomationModule/atoms/flows';
import { IAutomationEvent, IResponsePager } from '@/modules/AutomationModule/types/events';
import { IFlowData } from '@/modules/AutomationModule/types/flows';

export interface IGetAllFlowsPayload extends IOrderByTable {
  limit?: number;
  page?: number;
  search?: string | null;
  status?: number[] | null;
  triggers?: number[] | null;
  types?: number[] | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  counter?: boolean;
}
export interface IGetAllFlowsResponse {
  result: IFlowData[] | IAutomationEvent[];
  pager: IResponsePager;
}

export interface IGetAllEventsPayload extends IOrderByTable {
  limit?: number;
  page?: number;
  search?: string | null;
  status?: number[] | null;
  types?: number[] | null;
  triggers?: number[] | null;
  dateFrom?: string | null;
  dateTo?: string | null;
}

export interface IGetReportFlowsPayload {
  dateFrom?: string;
  dateTo?: string;
  gmt: number;
  isAction: boolean;
  guid: string;
  items: number[];
}
export interface IGetReportFlowsResponse {
  url: string;
}

export interface IGetReportEventsPayload {
  dateFrom?: string;
  dateTo?: string;
  gmt: number;
  eventId: number;
}

export interface IGetReportEventsResponse {
  url: string;
}

export interface IGetAllEventsResponse {
  result: IAutomationEvent[];
  pager: IResponsePager;
}

export interface GetApiResponse {
  apiKey: string;
  apiKeyBase64: string;
}

export interface IExecutedTrigger {
  triggerId: number;
  total: number;
}
export type IGetExecutedCountResponse = IExecutedTrigger[] | null;

export type IExecutedFlow = {
  id: number;
  contactId: number;
  email: string;
  date: string;
  data: any;
};

export type IExecutedEvent = {
  id: number;
  contactId: number;
  email: string;
  date: string;
  data: any;
};
export type IGetDetailExecutedCountResponse = {
  pager: {
    countTotal: number;
  };
  result: IExecutedEvent[] | IExecutedFlow[] | null;
};

export interface IGetExecutedFilters {
  dateFrom?: string;
  dateTo?: string;
  counter?: boolean;
  page?: number;
  limit?: number;
}
export interface IAutomationParamStart {
  jwt: string;
  url_ema_app_v1: string;
  url_ema_app_v2: string;
  url_flows_v1: string;
}

export interface IRequestErrorResult {
  error: boolean;
  type: string;
}

export interface CreateEventBody {
  name: string;
  description: string;
  attributes: string[];
  items: string[];
}

export interface EventDataResponse {
  name: string;
  description: string;
  attributes: string[];
  items: string[];
  integrationId?: number;
}

export interface EditEventBody extends CreateEventBody {
  id: number;
}

export type JourneyMessageTemplatesStatus = 'active' | 'inactive' | 'draft';
export type JourneyMessageSortField = 'name' | 'creationDate' | 'lastUpdate';
export interface GetJourneyMessagePayload {
  search?: string;
  page?: number;
  limit?: number;
  sortField?: JourneyMessageSortField;
  sortOrder?: 'asc' | 'desc';
  status?: JourneyMessageTemplatesStatus[];
  creationDateAfter?: Date | null;
  creationDateBefore?: Date | null;
}

export interface EventsAndFlowsPayload {
  search?: string;
  page?: number;
  limit?: number;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  status?: number[] | null;
  types?: number[] | null;
  triggers?: number[] | null;
  dateFrom?: string | null;
  dateTo?: string | null;
}

export type RulesSortField = 'name' | 'creationDate' | 'exeDate';

export interface GetRulesPayload {
  search?: string;
  page?: number;
  limit?: number;
  sortField?: RulesSortField;
  sortOrder?: 'asc' | 'desc';
  status?: JourneyMessageTemplatesStatus[];
  creationDateAfter?: Date | null;
  creationDateBefore?: Date | null;
  ruleTypesToFetch?: ETriggerActivityType[];
}

export enum ETriggerActivityType {
  TRIGGER_DATE = 1,
  SPECIFIC_ACTIVITY = 2,
  ACCUMULATED_ACTIVITY = 3,
  EXTERNAL_URL_CALL = 4,
  API_INTEGRATOR = 5,
  FORM = 6,
  ASSOCIATED_TAG = 7,
  FLOWS = 8,
}
export interface PaginationListResponse<T> {
  result: T[];
  pager: IResponsePager;
}
